export enum ContextMenuEnum {
    Category = 1,
    Item = 2
  }
  